import React, {Component} from 'react';
import {ModalBody, ModalFooter} from 'reactstrap';
import {TiendaNubeLinkComponent} from "../../agency/link_acocunts/TiendaNubeLink";
import { withTranslation } from 'react-i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

class AddTiendaNubeStoreFormClass extends Component {

    render() {
        const { t } = this.props;
        return (
            <div>
                <ModalBody>
                    <div className="modal-section">
                        <p>{t('add_store_modal.tienda_nube_redirect_message')}</p>
                        <div className="alert alert-info" style={{ fontSize: '0.9em', marginBottom: 0 }}>
                            <FontAwesomeIcon icon="info-circle" style={{ marginRight: '0.5em' }} />
                            {t('add_store_modal.tienda_nube_session_tip')}
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <TiendaNubeLinkComponent hasConnection={false} disabled={false} />
                </ModalFooter>
            </div>
        )
    }
}

export const AddTiendaNubeStoreForm = withTranslation()(AddTiendaNubeStoreFormClass);


